import { useManualPortfolioContext } from '../../../../PortfolioManual';

type Props = Parameters<
  ReturnType<typeof useManualPortfolioContext>['updatePortfolio']
>['0'];

export const UpdateManualHoldingsField = ({
  holdingId,
  portfolioId,
  holdingFieldToUpdate,
}: Props) => {
  const { updatePortfolio } = useManualPortfolioContext();
  return (
    <button
      onClick={() => {
        updatePortfolio({
          portfolioId,
          holdingId,
          holdingFieldToUpdate,
        });
      }}
    >
      <span className="text-xs text-brand-01">Add</span>
    </button>
  );
};
